<script setup lang="ts">
import AdminProjectManagement from '@/components/admin/project/AdminProjectManagement.vue';
import TabSelector from '@/components/admin/project/TabSelector.vue';
import UsersManagment from '@/components/admin/project/users/UsersManagment.vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const isUsersTab = computed(() => route.query.tab === 'anvandare');
</script>

<template>
  <TabSelector />

  <AdminProjectManagement v-if="!isUsersTab" />
  <UsersManagment v-else />
</template>
